import { type Country } from '../constants/country';
import { DEFAULT_LOCALE, Locale } from '../constants/locale';
import { getCountryLocale } from './locale';

/**
 *  Docs: https://docs.adyen.com/payment-methods/cards/custom-card-integration/#supported-card-types
 */
export type SupportedCardTypes = 'mastercard' | 'mc' | 'visa' | 'amex' | 'discover';

const CARD_BRANDS: Record<Locale, SupportedCardTypes[]> = {
    [Locale['en-US']]: ['mastercard', 'mc', 'visa', 'amex', 'discover'],
    [Locale['en-CA']]: ['mastercard', 'mc', 'visa', 'amex'],
};

export const getCartBrandsForLocale = (locale: Locale) => CARD_BRANDS[locale];

export const isCardBrandSupportedForLocale = (cardType: string | undefined, locale: Locale = DEFAULT_LOCALE): boolean =>
    !cardType || getCartBrandsForLocale(locale).includes(cardType.toLocaleLowerCase() as SupportedCardTypes);

export const isCardBrandSupportedForCountry = (cardType: string | undefined, country: Country): boolean =>
    isCardBrandSupportedForLocale(cardType, getCountryLocale(country));
